export const joinActionTypes = {
	SET_CURRENT_JOIN_STEP: 'SET_CURRENT_JOIN_STEP',
	SET_SELECTED_PRODUCT: 'SET_SELECTED_PRODUCT',
};
